// Pagination logic to show limited pages with "..."
export const RenderPagination = ({ currentPage, setCurrentPage, totalPages }) => {

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const pageNumbers = [];
    const maxVisiblePages = 5;

    // Calculate start and end page numbers
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage < maxVisiblePages - 1) {
        startPage = Math.max(1, endPage - (maxVisiblePages - 1));
    }

    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }

    return (
        <>
            {currentPage > 1 && (
                <li className="page-item">
                    <button className="page-link" onClick={() => paginate(currentPage - 1)}>Previous</button>
                </li>
            )}
            {startPage > 1 && (
                <li className="page-item">
                    <button className="page-link" onClick={() => paginate(1)}>1</button>
                </li>
            )}
            {startPage > 2 && <li className="page-item"><span className="page-link">...</span></li>}
            {pageNumbers.map(number => (
                <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => paginate(number)}>
                        {number}
                    </button>
                </li>
            ))}
            {endPage < totalPages - 1 && <li className="page-item"><span className="page-link">...</span></li>}
            {endPage < totalPages && (
                <li className="page-item">
                    <button className="page-link" onClick={() => paginate(totalPages)}>{totalPages}</button>
                </li>
            )}
            {currentPage < totalPages && (
                <li className="page-item">
                    <button className="page-link" onClick={() => paginate(currentPage + 1)}>Next</button>
                </li>
            )}
        </>
    );
};